import { option, record } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { parentSelector } from '../../../selectors/parentSelector';

const getChains = createSelector(parentSelector, (state) => state.entities.chains);
const getChain = createSelector(getStringProp('chainId'), getChains, (chainId, chains) =>
    pipe(chains, record.lookup(chainId))
);

export const getChainName = createSelector(
    getChain,
    flow(
        option.map((chain) => chain.name),
        option.toNullable
    )
);
